import React from "react";
import ReportTable from "../ReportTable";
import { principleTitles, renderYesNo, safeText } from "./helpers";
import usePrincipleData from "./usePrincipleData";

const Principle4 = ({ styles }) => {
  const { loading, principle } = usePrincipleData(4);
  const essential = principle?.essentialIndicators || {};
  const leadership = principle?.leadershipIndicator || {};

  const stakeholders = [
    ["Investors", "investors"],
    ["Shareholders", "shareholders"],
    ["Customers", "customers"],
    ["Business Partners", "businessPartners"],
    ["Employees & Workers", "employeesAndWorkers"],
    ["Regulatory Bodies", "regulatoryBodies"],
    ["Trade bodies & other organizations", "tradeBodies"],
    ["Local community", "localCommunity"],
  ];

  const stakeholderRows = stakeholders.map(([group, key], idx) => {
    const row = essential?.identificationOfStakeholders?.[key] || {};
    const channel =
      row?.channelOfCommunication === "Others"
        ? `Others: ${safeText(row?.newChannelOfCommunication, "N/A")}`
        : safeText(row?.channelOfCommunication, "N/A");
    const frequency =
      row?.frequency === "Others"
        ? `Others: ${safeText(row?.newFrequency, "N/A")}`
        : safeText(row?.frequency, "N/A");

    return {
      _id: `p4-e2-${idx}`,
      stakeholderGroup: group,
      identified: renderYesNo(row?.wheatherIdentified),
      channel,
      frequency,
      purpose: safeText(row?.purpose, "N/A"),
    };
  });

  return (
    <div className={styles.principleBlock}>
      <div className={styles.principleHeading}>{`PRINCIPLE 4: ${principleTitles[3]}`}</div>
      {loading ? <div className={styles.meta}>Loading principle 4...</div> : null}

      <div className={styles.band}>I. ESSENTIAL INDICATOR</div>

      <div className={styles.question}>
        1. Describe the processes for identifying key stakeholder groups of the entity.
      </div>
      <div className={styles.answer}>{safeText(essential?.stakeholderGroup, "N/A")}</div>

      <div className={styles.question}>
        2. List stakeholder groups identified as key for your entity and the frequency of
        engagement with each stakeholder group.
      </div>
      <ReportTable
        showSerialNumber={false}
        columns={[
          { field: "stakeholderGroup", label: "Stakeholder Group" },
          {
            field: "identified",
            label: "Whether identified as Vulnerable & Marginalised Group (Yes/No)",
          },
          {
            field: "channel",
            label:
              "Channels of communication (Email, SMS, Newspaper, Pamphlets, Advertisement, Community Meetings, Notice Board, Website), Others",
          },
          {
            field: "frequency",
            label:
              "Frequency of engagement (Annually/ Half yearly/ Quarterly / others please specify)",
          },
          {
            field: "purpose",
            label:
              "Purpose and scope of engagement including key topics and concerns raised during such engagement",
          },
        ]}
        rows={stakeholderRows}
      />

      <div className={styles.band}>II. LEADERSHIP INDICATOR</div>

      <div className={styles.question}>
        1. Provide the processes for consultation between stakeholders and the Board on economic,
        environmental, and social topics or if consultation is delegated, how is feedback from such
        consultations provided to the Board.
      </div>
      <div className={styles.answer}>
        {safeText(leadership?.stakeholderConsultationProcesses, "N/A")}
      </div>

      <div className={styles.question}>
        2. Whether stakeholder consultation is used to support the identification and management of
        environmental, and social topics (Yes / No). If so, provide details of instances as to how
        the inputs received from stakeholders on these topics were incorporated into policies and
        activities of the entity.
      </div>
      <div className={styles.answer}>
        {renderYesNo(leadership?.stakeholderConsultationIntegration?.action)}
        {leadership?.stakeholderConsultationIntegration?.action
          ? `, ${safeText(leadership?.stakeholderConsultationIntegration?.remark, "N/A")}`
          : ""}
      </div>

      <div className={styles.question}>
        3. Provide details of instances of engagement with, and actions taken to, address the
        concerns of vulnerable/ marginalized stakeholder groups.
      </div>
      <div className={styles.answer}>
        {safeText(leadership?.vulnerableStakeholderEngagement, "N/A")}
      </div>
      <div className={styles.pageBreak} />
    </div>
  );
};

export default Principle4;
